import Image from "next/image";

import Button from "@/components/button/Button";
import Heading from "@/components/heading/heading";
import { getImageUrl } from '@/utils/imageUrl'; 

import "./tour-card.scss";

interface TourCardProps {
    name: string;
    picture: any;
    location: string;
    place: string;
    price: string;
    type: string;
    list: {
        icon: string;
        title: string;
    }[];
}

const TourCard = (props: TourCardProps) => {
    const h = props;
    return (
        <div className="inline-flex flex-col tour-card card">
            <figure>
                <Image loading="lazy" src={h.picture} alt={h.name} width={302} height={210} />
                <figcaption className="flex-center py-2 px-4 gap-2">
                    <span className="font-medium text-white">{h.type}</span>
                </figcaption>
            </figure>
            <div className="tour-card-info flex flex-col gap-2 sm:gap-4 p-4">
                <div className="tour-card-details flex flex-col gap-2 sm:gap-4">
                    <div className="tour-card-location flex items-center gap-2">
                        <div className="flex items-center gap-1">
                            <Image loading="lazy" src={getImageUrl("/svg/destinations/hand-picked/location.svg")} alt="location"  width={18} height={19}/>
                            <span>{h.location}</span>
                        </div>
                        {h.place?<span className="tour-card-place dot">{h.place}</span> : null}
                    </div>
                    <Heading as="h6" className="h-12">
                        {h.name}
                    </Heading>
                    <ul className="flex flex-wrap items-center gap-3.5">
                        {h.list.map((item, index) => (
                            <li
                                key={index}
                                className="option-list-item flex items-center gap-1"
                            >
                                <Image loading="lazy"
                                    src={item.icon}
                                    alt={item.title}
                                    width={20}
                                    height={20}
                                />
                                <span className="font-medium ">
                                    {item.title}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="tour-card-bottom flex items-center justify-between pt-2 sm:pt-4">
                    <div className="person flex flex-col gap-3">
                        <span>Starting from</span>
                        <strong>
                            {h.price}
                            <span>/Person</span>
                        </strong>
                    </div>
                    <a href="#">
                    <Button className="flex items-center" variant="orange">
                        <span>Get Quote</span>
                    </Button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default TourCard;
